"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const index_1 = require("../../../index");
const interval = 5000 / 100 * 2; // 5 seconds - call for every 2% it ticks down (in ms)
const Toast = (props) => {
    var _a;
    const autoDismiss = (_a = props.toast.autoDismiss) !== null && _a !== void 0 ? _a : true;
    const [progress, setProgress] = React.useState(100);
    const [paused, setPaused] = React.useState(true);
    const [exiting, setExiting] = React.useState(false);
    React.useEffect(() => {
        // Don't start removing toast before transition in has completed
        const waitBeforeStart = setTimeout(() => setPaused(false), 2200);
        return () => {
            clearTimeout(waitBeforeStart);
        };
    }, []);
    React.useEffect(() => {
        const timer = setInterval(() => {
            if (!paused && autoDismiss) {
                setProgress((t) => t - 2); // minus 2 percent each time
            }
        }, interval);
        if (progress <= 0) {
            setExiting(true);
        }
        return () => {
            clearInterval(timer);
        };
    }, [progress, paused]);
    React.useEffect(() => {
        // Wait for transition out before removing toast
        const removeToast = setTimeout(() => {
            if (exiting) {
                closeToast();
            }
        }, 2000);
        return () => {
            clearTimeout(removeToast);
        };
    }, [exiting]);
    const closeToast = () => props.removeToast(props.toast.id);
    const stopProgress = () => setPaused(true);
    const continueProgress = () => setPaused(false);
    const toastIcon = () => {
        switch (props.toast.type) {
            case 'success':
                return 'check_green';
            case 'warning':
                return 'excl_yellow';
            case 'error':
                return 'excl_red';
            default:
                return 'info_blue';
        }
    };
    return (React.createElement("div", { className: `toast toast-${props.toast.type} ${exiting ? 'toast-exiting' : ''}`, role: "status", onMouseEnter: stopProgress, onMouseLeave: continueProgress, onTouchStart: stopProgress },
        React.createElement(index_1.Icon, { icon: toastIcon(), className: "toast-icon" }),
        React.createElement("div", { className: "toast-body" }, renderBody()),
        React.createElement("button", { type: "button", className: "close", "data-dismiss": props.toast.type, "aria-label": "Close", "aria-hidden": "true", onClick: closeToast },
            React.createElement(index_1.Icon, { icon: "cross" })),
        React.createElement("span", { className: "progress-bar", style: { width: `${progress}%` } })));
    function renderBody() {
        if (typeof props.toast.body === 'string') {
            return React.createElement("p", null, props.toast.body);
        }
        return React.createElement("div", null,
            " ",
            props.toast.body,
            " ");
    }
};
exports.default = Toast;
//# sourceMappingURL=toast.js.map